import React, { useState, useEffect } from "react";
import { IoIosArrowDown, IoIosArrowForward } from "react-icons/io";
import { Link, useLocation } from "react-router-dom";

export const subMenus = {
  IoMenu: [],
  "All Projects": [
    { name: "Project Performance", path: "/ads-project-performance" },
    { name: "Project List", path: "/projects" },
    { name: "Project details", path: "/project-details", hidden: true },
  ],
  "Paid Ads": [
    { name: "Performance", path: "/google-ads/campaigns" },
    { name: "Reporting", path: "/google-ads/reporting/weekly-reporting" },
    { name: "Group Setting", path: "/google-ads/group" },
    { name: "Monthly Budget", path: "/google-ads/monthy-budget" },
    { name: "Project Setting", path: "/google-ads/setting/:projectId" },
  ],
  Alerts: [
    { name: "Google Ads", path: "/google-ads-alerts" },
    { name: "Bing Ads", path: "/bing-ads-alerts" },
  ],
  Tools: [
    { name: "Task", path: "/create-task/:projectId" },
    { name: "Change Log", path: "/tools/change-log/:projectId" },
    { name: "Seed Keyword Analysis", path: "/seed-keyword-analysis" },
    { name: "Ad Copy Crafting", path: "/tools/ad-crafting" },
    {
      name: "Onboarding Audit",
      path: "/onboarding-audit",
      projectIdRequired: true,
    },
  ],
  Admin: [
    { name: "Account Setting", path: "/profile" },
    { name: "Support", path: "/customer-support" },
    { name: "Billing", path: "/billing-support" },
  ],
};

const dropdownOptions = {
  Performance: [
    { name: "Campaigns", path: "/google-ads/campaigns" },
    { name: "Locations", path: "/google-ads/locations" },
    { name: "Ads", path: "/google-ads/ads" },
    { name: "Keywords", path: "/google-ads/search-keywords" },
    { name: "Customer Search Pattern", path: "/google-ads/search-terms" },
    { name: "Ads - PromoRecap", path: "/tools/ads-PromoRecap" },
    { name: "Confi-ai", path: "/confi-ai" },
    { name: "Bid Strategies", path: "/bid-strategies" },
  ],
  Reporting: [
    { name: "Daily Reporting", path: "/google-ads/reporting/daily-reporting" },
    {
      name: "Weekly Reporting",
      path: "/google-ads/reporting/weekly-reporting",
    },
    {
      name: "Monthly Reporting",
      path: "/google-ads/reporting/monthly-reporting",
    },
    { name: "Custom Reporting", path: "/google-ads/custom-reporting" },
  ],
};

const Submenu = ({ menu, onClose }) => {
  const location = useLocation();
  const [openDropdown, setOpenDropdown] = useState(null); // State to track the single open dropdown
  const [activeIndex, setActiveIndex] = useState(null);
  const [menuItems, setMenuItems] = useState([]);

  useEffect(() => {
    const projectId = localStorage.getItem("project_id");
    const customerId = localStorage.getItem("customer_id");

    if (window.location.pathname === "/projects") {
      localStorage.removeItem("project_name");
    }

    const updatedMenus = JSON.parse(JSON.stringify(subMenus)); // deep copy
    // 1. ALWAYS filter out hidden items first, regardless of projectId
    Object.keys(updatedMenus).forEach((menuKey) => {
      updatedMenus[menuKey] = updatedMenus[menuKey].filter(
        (item) => item.hidden !== true,
      );
    });

    if (projectId) {
      Object.keys(updatedMenus).forEach((menuKey) => {
        updatedMenus[menuKey] = updatedMenus[menuKey].map((item) => {
          if (item.path && item.path.includes(":projectId")) {
            return {
              ...item,
              path: item.path.replace(":projectId", projectId),
            };
          }
          return item;
        });
      });

      const hasChangeLog = updatedMenus["Tools"].some(
        (item) => item.name === "Change Log",
      );

      if (!hasChangeLog) {
        updatedMenus["Tools"].push({
          name: "Change Log",
          path: `/tools/change-log/${projectId}`,
        });
      }
    }

    // Filter out specific Tools items if customer_id is missing
    if (!customerId && updatedMenus["Tools"]) {
      updatedMenus["Tools"] = updatedMenus["Tools"].filter(
        (item) =>
          ![
            "Change Log",
            "Ads - PromoRecap",
            "Ad Copy Crafting",
            "Task",
            // "Onboarding Audit",
          ].includes(item.name),
      );
    }

    setMenuItems(updatedMenus[menu] || []);
    if (menu === "IoMenu") {
      onClose();
    }
  }, [menu, onClose]);

  const handleDropdownToggle = (itemName) => {
    // If the clicked dropdown is already open, close it. Otherwise, open it.
    setOpenDropdown(openDropdown === itemName ? null : itemName);
    setActiveIndex(openDropdown === itemName ? null : itemName);
  };

  return (
    <div className="w-64 bg-gray-50 text-gray-900 shadow-lg rounded-lg p-2 h-full transition-transform duration-200 ease-in-out">
      <div className="flex justify-between items-center border-b pb-2">
        <h2 className="text-lg font-semibold">{menu}</h2>
        <button
          className="text-gray-700 hover:text-gray-900 font-bold text-xl"
          onClick={onClose}
          aria-label="Close submenu"
        >
          ✕
        </button>
      </div>

      <ul className="mt-4 space-y-2">
        {menuItems.map((item) => {
          const isDropdown = dropdownOptions[item.name];
          const basePath = item.path?.split("/:")[0];
          const isActive = location.pathname.startsWith(basePath);
          const isDropdownOpen = openDropdown === item.name;
          return (
            <li key={`${menu}-${item.name}`} className="relative">
              {!isDropdown ? (
                <Link
                  to={item.path}
                  className={`block p-3 rounded-full font-medium transition hover:bg-gray-200 ${
                    isActive ? "bg-blue-500 text-white" : ""
                  }`}
                  onClick={() => {
                    if (
                      item.path === "/projects" ||
                      item.path === "/ads-project-performance"
                    ) {
                      localStorage.removeItem("project_name");
                      localStorage.removeItem("project_id");
                      localStorage.removeItem("customer_id");
                    }
                    onClose();
                  }}
                >
                  {item.name}
                </Link>
              ) : (
                <>
                  <div
                    role="button"
                    tabIndex={0}
                    onClick={() => handleDropdownToggle(item.name)}
                    onKeyDown={(e) => {
                      if (e.key === "Enter") handleDropdownToggle(item.name);
                    }}
                    className={`p-3 flex justify-between items-center rounded-full font-medium cursor-pointer transition hover:bg-gray-200 ${
                      activeIndex === item.name ? "bg-blue-500 text-white" : ""
                    }`}
                    aria-expanded={isDropdownOpen}
                    aria-controls={`${item.name}-dropdown`}
                  >
                    <span>{item.name}</span>
                    {isDropdownOpen ? (
                      <IoIosArrowDown className="text-gray-600" />
                    ) : (
                      <IoIosArrowForward className="text-gray-600" />
                    )}
                  </div>

                  <ul
                    id={`${item.name}-dropdown`}
                    className={`ml-2 mt-2 bg-gray-50 rounded-lg p-2 space-y-2 overflow-hidden transition-all duration-300 ease-in-out ${
                      isDropdownOpen
                        ? "max-h-96 opacity-100"
                        : "max-h-0 opacity-0"
                    }`}
                    style={{ transitionProperty: "max-height, opacity" }}
                  >
                    {dropdownOptions[item.name].map((option) => {
                      const isSubActive = location.pathname === option.path;

                      return (
                        <li key={`${item.name}-${option.name}`}>
                          <Link
                            to={option.path}
                            className={`block p-2 text-sm rounded-full transition hover:bg-blue-200 ${
                              isSubActive
                                ? "bg-blue-500 text-white"
                                : "hover:text-blue-700"
                            }`}
                            onClick={onClose}
                          >
                            {option.name}
                          </Link>
                        </li>
                      );
                    })}
                  </ul>
                </>
              )}
            </li>
          );
        })}
      </ul>
    </div>
  );
};

export default Submenu;
